import type { CallOffsQueryParams } from './useQueryCallOffs';

import type { UUID } from '~/types/common';

import { unique } from '@vestigas/utils';

/**
 * Query key factory for call-off-related queries.
 */
export const queryKeysCallOff = {
  base: () => 'calloffs' as const,
  get: (callOffId: UUID) =>
    [queryKeysCallOff.base(), 'detail', { callOffId }] as const,
  getAll: (queryParams?: Partial<CallOffsQueryParams>) => {
    const normalized = queryParams
      ? {
          ...queryParams,
          accountingReferenceIds: queryParams.accountingReferenceIds
            ? unique(queryParams.accountingReferenceIds)
                .filter(Boolean)
                .toSorted()
            : undefined,
          siteIds: queryParams.siteIds
            ? unique(queryParams.siteIds).filter(Boolean).toSorted()
            : undefined,
        }
      : queryParams;
    return [queryKeysCallOff.base(), 'list', normalized].filter(Boolean);
  },
  getBuyerActions: (callOffId: UUID) =>
    [queryKeysCallOff.base(), 'buyerActions', { callOffId }] as const,
  getHistory: (callOffId: UUID) =>
    [queryKeysCallOff.base(), 'history', { callOffId }] as const,
  getItems: (callOffId: UUID) =>
    [queryKeysCallOff.base(), 'items', { callOffId }] as const,
  getStorageLocations: (queryParams?: Record<string, unknown>) =>
    [queryKeysCallOff.base(), 'storageLocations', queryParams].filter(Boolean),
  getSupplierContacts: (queryParams?: Record<string, unknown>) =>
    [queryKeysCallOff.base(), 'supplierContacts', queryParams].filter(Boolean),
  getViaMagicLink: (callOffId: UUID, token: string) =>
    [queryKeysCallOff.base(), 'magicLink', { callOffId, token }] as const,
} as const;
